/*
  XOL-67 (decision 175): the map's gesture handling by device, for the GoogleMap atom.

  A desktop (a mouse or a trackpad is the primary pointer) gets 'cooperative': a plain wheel scrolls the page, Ctrl / Cmd + wheel zooms the map. A phone
  or tablet (a finger is the primary pointer, `pointer: coarse`) gets 'greedy': one finger moves the map and two pinch-zoom it, as in a maps app.
  The primary pointer decides, so a touchscreen laptop used with its trackpad is a desktop, and an iPad with a keyboard is a tablet.
  With no matchMedia (an old browser, jsdom) it is a desktop.
*/

export var DESKTOP = 'cooperative'
export var TOUCH = 'greedy'

export function isTouchPrimary (win) {
  var w = win || (typeof window !== 'undefined' ? window : null)

  if (!w || typeof w.matchMedia !== 'function') return false

  try {
    return !!w.matchMedia('(pointer: coarse)').matches
  } catch (e) {
    return false
  }
}

export function deviceGestureHandling (win) {
  return isTouchPrimary(win) ? TOUCH : DESKTOP
}
